import { render, staticRenderFns } from "./CreateUserIntegrationSettings.vue?vue&type=template&id=179588d6&scoped=true&"
import script from "./CreateUserIntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./CreateUserIntegrationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179588d6",
  null
  
)

export default component.exports